export default "__VITE_ASSET___eQdEFuD__"